<template>
<v-container class="container--fluid text-center">
     <AuthCtrl :parm_step="11"></AuthCtrl>
    <v-row>
        <v-col>
            <app-widget-stepper e1="5"></app-widget-stepper>

        </v-col>
    </v-row>
    <!--<v-row>
        <v-col>{{this.SplitvarList}}</v-col>
    </v-row>
    <v-row>
        <v-col>{{this.tbd_caldate}}</v-col>
    </v-row>
    <v-row>
        <v-col>{{ this.finallistfordb}}</v-col>
    </v-row>-->
    <!-- <v-row>
        <v-col cols="6" sm="6" md="4">
            {{ date }}**********
            {{this.arrayDatesnew}}
            {{this.maxdate}}
            {{this.mindate}}
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="6" sm="6" md="4">
            <v-date-picker range v-model="date" :allowed-dates="allowedDates" class="mt-3" :min="mindate" :max="maxdate"></v-date-picker>
        </v-col>

    </v-row>-->
    <v-row>
        <v-col>
            <v-card>
                <v-app-bar flat dense color="white">

                    <v-btn @click="onclickbtn(1)" depressed class="mr-2" v-bind:class="bttype === 1 ? 'selectedbtn' : 'nonselectedbtn'">
                        <v-icon right dark> mdi-cog-transfer </v-icon>
                        <span class="button-caption">Parameter</span>

                    </v-btn>
                    <v-btn @click="onclickbtn(2)" depressed v-bind:class="bttype === 2 ? 'selectedbtn' : 'nonselectedbtn'" class="mr-2">
                        <v-icon right dark> mdi-post-outline</v-icon>
                        <span class="button-caption">Data</span>

                    </v-btn>

                    <v-spacer></v-spacer>

                </v-app-bar>
            </v-card>
        </v-col>
    </v-row>
    <v-row>
        <v-col>
            <v-container v-if="bttype === 1" class="container--fluid text-center">

                <div style="min-height:300px;">
                    <v-simple-table fixed-header height="330px">
                        <template v-slot:default>

                            <thead>
                                <tr>
                                    <th class="text-center">
                                        Name
                                    </th>
                                    <th class="text-center">
                                        Split1
                                    </th>
                                    <th class="text-center">
                                        Split2
                                    </th>
                                    <th class="text-center">
                                        Split3
                                    </th>

                                </tr>
                            </thead>
                            <tbody>

                                <tr class="text-center" v-for="item in SplitvarList" :key="item">
                                    <td class="text-center">{{ item.name }}</td>
                                    <td class="text-center">

                                        <template class="text-center">
                                            <v-btn color="primary" dark @click="opendilog(item.name,item.index,1)">
                                                {{ item.splitrangetxt_1 }}
                                            </v-btn>
                                        </template> </td>
                                    <td class="text-center">

                                        <template class="text-center">
                                            <v-btn color="primary" dark @click="opendilog(item.name,item.index,2)">
                                                {{ item.splitrangetxt_2 }}
                                            </v-btn>
                                        </template> </td>
                                    <td class="text-center">

                                        <template class="text-center">
                                            <v-btn color="primary" dark @click="opendilog(item.name,item.index,3)">
                                                {{ item.splitrangetxt_3 }}
                                            </v-btn>
                                        </template> </td>

                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </div>
            </v-container>
            <v-container v-if="bttype === 2" class="container--fluid text-center">
               <!-- <div>{{this.ListSplitDataFortab}}</div>-->
                <div style="min-height:300px;">
                    <v-simple-table fixed-header height="400px">
                        <template v-slot:default>
                            <thead>
                                <tr class="text-capitalize text-center">
                                    <th class="text-capitalize text-center" v-for='(item, key) in ListSplitDataFortab[0]' :key='key'><span>
                                            {{key}}
                                        </span></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="text-center" v-for='mmdata in ListSplitDataFortab' :key='mmdata.id'>
                                    <td class="text-center" v-for='(item, key) in mmdata' :key='key'>

                                       {{item}} </td>

                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </div>
            </v-container>
        </v-col>
    </v-row>
    <v-container class="container--fluid text-center" >
       <!-- <v-row>
            <v-col>
                <v-card>
                    <v-app-bar flat dense color="white">
                        <v-btn color="white" class="mr-2" @click="$router.push('/variabletransformation')">
                            <v-icon right dark> mdi-arrow-left-bold </v-icon>
                            <span class="button-caption">back</span>

                        </v-btn>
                        <v-spacer></v-spacer>

                      
                        <v-btn depressed color="white" class="mr-2" @click="onPreviewclick()">
                            <v-icon right dark> mdi-file-find </v-icon>
                            <span class="button-caption">Preview</span>

                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn depressed color="white" class="mr-2" @click="savedataInDB()">
                            <v-icon right dark> mdi-arrow-right-bold </v-icon>
                            <span class="button-caption">Save.</span>

                        </v-btn>

                    </v-app-bar>
                </v-card>
            </v-col>
        </v-row>-->
         <v-row>
                    <v-col>
                        <CtrlNavButton @OnPreviewClick="onPreviewclick()" @OnbackClick="$router.push('/variabletransformation')" @OnNextClick="savedataInDB()"></CtrlNavButton>
                    </v-col>
                </v-row>
    </v-container>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="400px">

            <v-card>
                <v-card-title class="text-center">
                    <span class="text-h5 text-center">Split Range</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row class="text-center">
                            <v-col cols="12">
                                <v-date-picker range v-model="date" :allowed-dates="allowedDates" class="mt-3" :min="mindate" :max="maxdate"></v-date-picker>
                            </v-col>
                        </v-row>
                        <v-row class="text-center">
                            <v-col class="text-center">{{strselectdaterange}}</v-col>
                        </v-row>
                    </v-container>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closedilog()">
                        Close
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="savedilog()">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</v-container>
</template>

<script>
import AuthCtrl from '../../../components/AuthAction.vue';
import AppWidgetStepper from "../components/WidgetStepper.vue";
import {
    defineComponent
} from '@vue/composition-api';
import globalclass from "../../../global/globalvar";
import apifactory from "../api";
import CtrlNavButton from "../../../components/CtrbuttonSaveAndNext.vue";
//import moment from 'moment';

export default defineComponent({
    components: {

        AppWidgetStepper,AuthCtrl,CtrlNavButton

    },
    data: () => ({
        currentprojectid: "0",
        prevstepQueryStringParm: [],
        prevstepQueryStringParmUrl: [],
        stepidCurrent: globalclass.PARAM_Step_MDP_SVT,
        stepidPrevious: globalclass.PARAM_Step_MDP_AS,
        SplitvarList: [],
        bttype: 1,

        date: [],
        arrayDates: ['2021-01-01', '2021-02-01', '2021-03-01', '2021-04-25'],
        arrayDatesnew: [],
        maxdate: '',
        mindate: '',

        dialog: false,
        selectectedvarname: '',
        selectedindex: -1,
        slelectedsplitcolumn: 0,
        finallistfordb: [],

        split_varbyvarname_list: [],
        tbd_caldate: '',

        ListSplitDataFortab: []

    }),
    methods: {
        onclickbtn(varbttype) {

            this.bttype = varbttype;
        },
        allowedDates12: val => parseInt(val.split('-')[2], 10) % 2 === 0,
        allowedDates(val) {
            for (var i = 0; i < this.arrayDates.length; i++) {
                if (this.arrayDates[i] == val) {
                    return val
                }
            }
        },
        opendilog(varname, indexid, splitid) {
            //alert(indexid);
            this.resetcalander();
            this.selectedindex = indexid;
            this.slelectedsplitcolumn = splitid;
            //alert(splitid);
            this.selectectedvarname = varname;
            this.get_split_varbyvarname();
            this.dialog = true;
        },
        closedilog() {
            this.resetcalander();
            this.dialog = false;
        },
        resetcalander() {
            this.date = [];
            this.selectedindex = null;
            this.slelectedsplitcolumn = null;
            this.selectectedvarname = null;
        },
        savedilog() {

            //lettodate=new Date(this.date[1]).getTime();
            let newdate = this.date[0] + "~~~" + this.date[1];
            this.tbd_caldate = newdate;
            let finalval1 = '';
            let finalval2 = '';
            let finalval = '';
            for (var k = 0; k < this.split_varbyvarname_list.length; k++) {

                if (parseInt(this.split_varbyvarname_list[k].t_date_otherinTime) === parseInt(new Date(this.date[0]).getTime())) {
                    this.split_varbyvarname_list[k].ismatch = 1;
                    finalval1 = this.split_varbyvarname_list[k].row;
                    //alert("ddd" + this.split_varbyvarname_list[k].row);

                }
                if (parseInt(this.split_varbyvarname_list[k].t_date_otherinTime) === parseInt(new Date(this.date[1]).getTime())) {
                    this.split_varbyvarname_list[k].ismatch = 1;
                    finalval2 = this.split_varbyvarname_list[k].row;
                    //alert("ddd" + this.split_varbyvarname_list[k].row);

                }
            }
            finalval = finalval1 + "," + finalval2;
            for (var i = 0; i < this.SplitvarList.length; i++) {
                if (this.SplitvarList[i].index === this.selectedindex) {
                    this.SplitvarList[i]["splitrangeval_" + this.slelectedsplitcolumn] = finalval;
                    this.SplitvarList[i]["splitrangetxt_" + this.slelectedsplitcolumn] = 'Edit';
                    this.SplitvarList[i].splitstr = '';
                    if (this.SplitvarList[i].splitrangeval_1 != "-1") {
                        this.SplitvarList[i].splitstr = this.SplitvarList[i].splitrangeval_1;
                    }
                    if (this.SplitvarList[i].splitrangeval_2 != "-1") {
                        this.SplitvarList[i].splitstr = this.SplitvarList[i].splitstr + "," + this.SplitvarList[i].splitrangeval_2;
                    }
                    if (this.SplitvarList[i].splitrangeval_3 != "-1") {
                        this.SplitvarList[i].splitstr = this.SplitvarList[i].splitstr + "," + this.SplitvarList[i].splitrangeval_3;
                    }
                    this.SplitvarList[i].isfordb = 1;

                }

            }
            this.splitvarforDB();
            //this.dialog=false;

        },
        savedataInDB() {
            //alert('ddd2');
            //this.splitvarforDB();
            //alert('ddd1');
            this.spiltvaribalesaveinDB();
            this.saveAndSetStepParms();
        },
        splitvarforDB() {
            this.finallistfordb = [];
            for (var k = 0; k < this.split_varbyvarname_list.length; k++) {
                if (this.SplitvarList[k].isfordb === 1) {
                    let obj = new Object();
                    obj.variable = this.SplitvarList[k].name;
                    let strsplitvalue = this.SplitvarList[k].splitstr.split(',');
                    let temparray = [];
                    //alert(strsplitvalue);
                    for (var j = 0; j < strsplitvalue.length; j++) {
                        if (strsplitvalue[j].length > 0) {
                            temparray.push(parseInt(strsplitvalue[j]));
                        }
                    }

                    obj.split = temparray;
                    this.finallistfordb.push(obj);
                }
            }

        },
        onPreviewclick() {
            // alert(JSON.stringify(this.finallistfordb));
            this.spiltvaribalesaveinDB();
            this.getsplitdataforDataTab();
        },
        spiltvaribalesaveinDB() {
            // alert('ddd');
            apifactory.splitvar_save_split(JSON.stringify(this.finallistfordb))
                .then((res) => {
                    // alert(res.id);

                    if (res.status != 200) {
                        //this.countryList = null;
                        alert(res.message);

                    } else {

                       // alert("done");
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                });
        },
        get_split_varbyvarname() {
            // this.allowdatelist=[],

            let temarray = [];
            let temarraydates = [];

            apifactory.splitvar_get_split_varbyvarname(this.selectectedvarname)
                .then((res) => {
                    // alert(res.id);

                    if (res.status != 200) {
                        //this.countryList = null;
                        alert(res.message);

                    } else {

                        temarray = res.data;
                        // this.split_varbyvarname_list = res.data;
                        this.split_varbyvarname_list = [];
                        for (var i = 0; i < temarray.length; i++) {

                            //   let nameArr = temarray[i].t_date.split('-');

                            //let newdatetemp = nameArr[2] + "-" + nameArr[0] + "-" + nameArr[1];
                            let newdatetemp = temarray[i].t_date;
                            // temarraydates.push(new Date(nameArr[2], nameArr[0], nameArr[1]));
                            temarraydates.push(temarray[i].t_date);
                            //new Date(nameArr[2],nameArr[0],nameArr[1]).getDate();
                            this.arrayDatesnew.push(temarray[i].t_date);

                            let obj = new Object();
                            obj.row = temarray[i].row;
                            obj.t_date = temarray[i].t_date;

                            obj.t_date_intime = new Date(temarray[i].t_date).getTime();
                            obj.t_date_other = newdatetemp;
                            obj.t_date_otherinTime = new Date(newdatetemp).getTime();
                            obj.ismatch = 0;
                            this.split_varbyvarname_list.push(obj);
                        }

                        this.arrayDates = [];
                        this.arrayDates = this.arrayDatesnew;
                        this.maxdate = new Date(Math.max.apply(Math, temarraydates)).toISOString().slice(0, 10);
                        this.mindate = new Date(Math.min.apply(Math, temarraydates)).toISOString().slice(0, 10);

                    }
                })
                .catch(function (error) {
                    console.warn(error);
                });
        },
        gettransformdata() {
            //this.tempallowdate = [],
            this.SplitvarList = [];
            let temarray = [];

            apifactory.splitvar_getsplitvarlist()
                .then((res) => {
                    // alert(res.id);

                    if (res.status != 200) {
                        //this.countryList = null;
                        alert(res.message);

                    } else {
                        temarray = res.data;
                        let index = 1;
                        for (var k in temarray) {
                            //t_date
                            let tempobj = new Object();
                            tempobj.index = index;
                            tempobj.name = k;
                            tempobj.splitrange_1 = '';
                            tempobj.splitrangeval_1 = '-1';
                            tempobj.splitrangetxt_1 = 'Split';
                            tempobj.splitrange_2 = '';
                            tempobj.splitrangeval_2 = '-1';
                            tempobj.splitrangetxt_2 = 'Split';
                            tempobj.splitrange_3 = '';
                            tempobj.splitrangeval_3 = '-1';
                            tempobj.splitrangetxt_3 = 'Split';
                            tempobj.splitstr = '';
                            tempobj.isfordb = 0;
                            this.SplitvarList.push(tempobj);
                            index = index + 1;
                        }

                    }
                })
                .catch(function (error) {
                    console.warn(error);
                });
        },
        getsplitdataforDataTab() {

            apifactory.splitvar_get_split_data()
                .then((res) => {

                    if (res.status != 200) {
                        // return false;
                        alert("Sorry");

                    } else {
                        this.ListSplitDataFortab = res.data;
                        // this.$store.commit("ModelDataPreparation/ADD_ITEM", 1);
                        //this.$router.push('/adstockdecay');

                    }
                })
                .catch(function (error) {
                    alert(error);
                    // return false;
                });
        },
        saveAndSetStepParms() {
            let url_querystring = "test=11";

            apifactory.addParameterBySteps(globalclass.PARAM_Step_MDP_SVT, url_querystring)
                .then((res) => {

                    if (res.status != 200) {
                        // return false;
                        alert("Sorry");

                    } else {
                        // this.$store.commit("ModelDataPreparation/ADD_ITEM", 1);
                        //this.$router.push('/adstockdecay');
                         this.$router.push('/modeldata');

                    }
                })
                .catch(function (error) {
                    alert(error);
                    // return false;
                });

        },
    },
    mounted() {
        this.gettransformdata();
        // this.selectectedvarname = "a_non_clm_call_retention_50%";
        // this.get_split_varbyvarname();

    },
    computed: {
        strselectdaterange: function () {
            let str = '';
            if (this.date[0] != null) {
                str = str + "From Date :" + this.date[0];
            }
            if (this.date[1] != null) {
                str = str + "To Date :" + this.date[1];
            }
            return str;
        }

    }
})
</script>

<style scoped>
.title_text {
    font-size: 15px !important;
}

.v-label {
    font-size: 10px !important;
}

.v-input__slot label {
    width: 5% !important;
}

.selectedbtn {
    background-color: #0177b2 !important;
    color: white !important;
}

.nonselectedbtn {
    background-color: lightgrey !important;
    color: black !important;

}

.span_new {
    font-size: 12px !important;
    word-wrap: break-word;
    word-break: break-all;
}

.div_content {
    overflow: auto;
    height: 300px;
}
</style>
